import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["clsPrefix", "onKeyDown", "className", "extraContent", "style", "tabBarPosition", "children", "direction"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getDataAttr } from './utils';

var TabBarRootNode = /*#__PURE__*/function (_React$Component) {
  _inherits(TabBarRootNode, _React$Component);

  var _super = _createSuper(TabBarRootNode);

  function TabBarRootNode() {
    var _this;

    _classCallCheck(this, TabBarRootNode);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getExtraContentStyle", function () {
      var _this$props = _this.props,
          tabBarPosition = _this$props.tabBarPosition,
          direction = _this$props.direction;
      var topOrBottom = tabBarPosition === 'top' || tabBarPosition === 'bottom';

      if (direction === 'rtl') {
        return topOrBottom ? {
          float: 'left'
        } : {};
      }

      return topOrBottom ? {
        float: 'right'
      } : {};
    });

    return _this;
  }

  _createClass(TabBarRootNode, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          clsPrefix = _this$props2.clsPrefix,
          onKeyDown = _this$props2.onKeyDown,
          className = _this$props2.className,
          extraContent = _this$props2.extraContent,
          style = _this$props2.style,
          tabBarPosition = _this$props2.tabBarPosition,
          children = _this$props2.children,
          direction = _this$props2.direction,
          restProps = _objectWithoutProperties(_this$props2, _excluded);

      var cls = classnames("".concat(clsPrefix, "-bar"), {// [className]: !!className,
      });
      var topOrBottom = tabBarPosition === 'top' || tabBarPosition === 'bottom';
      var extraContentStyle = extraContent && extraContent.props ? extraContent.props.style : {};
      var newChildren = children;

      if (extraContent) {
        newChildren = [/*#__PURE__*/cloneElement(extraContent, {
          key: 'extra',
          style: _objectSpread(_objectSpread({}, this.getExtraContentStyle(topOrBottom, direction)), extraContentStyle)
        }), /*#__PURE__*/cloneElement(children, {
          key: 'content'
        })];
        newChildren = topOrBottom ? newChildren : newChildren.reverse();
      }

      return /*#__PURE__*/React.createElement("div", _extends({
        role: "tablist",
        className: cls,
        tabIndex: "0",
        ref: this.props.saveRef('root'),
        onKeyDown: onKeyDown // style={style}

      }, getDataAttr(restProps)), newChildren);
    }
  }]);

  return TabBarRootNode;
}(React.Component);

export { TabBarRootNode as default };
TabBarRootNode.propTypes = {
  clsPrefix: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  tabBarPosition: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
  children: PropTypes.node,
  extraContent: PropTypes.node,
  onKeyDown: PropTypes.func,
  saveRef: PropTypes.func,
  direction: PropTypes.oneOf(['ltr', 'rtl'])
};
TabBarRootNode.defaultProps = {
  clsPrefix: '',
  className: '',
  style: {},
  tabBarPosition: 'top',
  extraContent: null,
  children: null,
  onKeyDown: function onKeyDown() {},
  saveRef: function saveRef() {}
};


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-tabs/src/TabBarRootNode.js